/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductMasterModel>>;
export function request(
  body: defs.basics.ProductMasterRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
